// @ts-check
import { useParamRef } from '@erpagroapp/params';
import readingError from '@/static/sounds/ErrorLectura.mp3';
import { useSound } from '@/composables/useSound';
import { HiNotification } from '../common/HINotificationSupport';

const soundAndVibration = useParamRef('AlertaSonoraVibracionLecturaCodigoBarras');
/** @type {ReturnType<typeof useSound> | null} */
let sound = null;

/**
 * Displays a notification toast and triggers sound/vibration alert if enabled.
 * @param {string} [text] - The toast message to display.
 * @returns {void}
 */
export function notifyReadingError(text) {
  if (text) {
    HiNotification.Toast(text, 3000);
  }

  if (soundAndVibration.value) {
    if (!sound) {
      sound = useSound(readingError, { interrupt: true });
    }

    navigator.vibrate?.(200);
    sound.play();
  }
}
